// extracted by mini-css-extract-plugin
module.exports = {"text_area_modal":"index--text_area_modal--1Cw1G"};